import React from "react";
import { Box, Card, CardContent, Container, makeStyles, Typography } from "@material-ui/core";
import { useParams } from "react-router";
import MissingResourceAlert from "../resource/MissingResourceAlert";
import CenteredSpinner from "../loading/CenteredSpinner";
import { getSharedResource } from "../../services/resource/resourceApi";
import { useQuery } from 'react-query';
import Media from "./Media";
import DownloadButton from "./DownloadButton";

const useStyles = makeStyles(theme => ({
    root: {
        margin: 'auto',
        padding: '0px',
    },
}));

const SharedFile = () => {
    let { accessor } = useParams();
    const classes = useStyles();

    const { data, isLoading } = useQuery(['/shared-resource/{accessor}', 'getSharedResource', accessor], () => getSharedResource(accessor));
    if (isLoading) {
        return (
            <Container maxWidth="xl">
                <Box m={2}>
                    <CenteredSpinner/>
                </Box>
            </Container>
        );
    }
    if (!data) {
        return (
            <Container maxWidth="xl">
                <Box m={2}>
                    <MissingResourceAlert/>
                </Box>
            </Container>
        );
    }
    
    const previewDirectLinkUrl = `/api/shared-resource/${accessor}/preview/download`;
    const directLinkUrl = `/api/shared-resource/${accessor}/download`;

    return (
        <Container className={classes.root} maxWidth="xl">
            <Box m={0}>
                <Card square={true}>
                    <Media type={data.type} previewState={data.preview_state} url={directLinkUrl} previewUrl={previewDirectLinkUrl} />
                    <CardContent>
                        <Typography variant="h5" component="div">
                            {data.name}
                        </Typography>
                        <Box mt={2}>
                            <DownloadButton url={directLinkUrl}/>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
}

export default SharedFile;